import PlaceholderReact from 'components/atomic/PlaceholderReact'
import Breadcrumbs from '../atomic/Breadcrumbs'
import { LandingIscrizione } from 'react-components/molecules'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import { Button } from 'react-components/atoms'
import { useTrans } from 'hooks'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { api } from 'utils'
import { PAGINAISCRIZIONE } from 'utils/endpoint'
import Link from 'next/link'
import Login from 'components/atomic/Login'

const Modal = dynamic(() => import('components/atomic/Modal'))

const LandingTemplate = ({ page, newPlaceholder }) => {
  const router = useRouter()
  const t = useTrans()
  const { utente } = useSelector((state) => state.utente)

  const [guest, setGuest] = useState(false)
  const [confermaScuola, setConfermaScuola] = useState(false)
  const [login, setLogin] = useState(false)
  const [next, setNext] = useState('')
  const [feedback, setFeedback] = useState('')
  const shouldShowCta = page?.mostra_cta_iscrizione ?? true

  const handleLogin = (login, nextPage = '') => {
    if (nextPage) setNext(nextPage)
    setGuest(false)
    setLogin(login)
  }

  const scuolaObj = utente?.utente_scuola?.[0]?.scuola || {}

  const labelScuola = `${scuolaObj?.classe}${scuolaObj?.classe ? '°' : ''}${scuolaObj?.sezione} - ${
    scuolaObj?.nome_scuola
  }`

  const handleApi = () => {
    const params = { idPagina: page.id, idUtente: utente.id }

    api
      .post(`${PAGINAISCRIZIONE}`, { params })
      .then((response) => {
        if (response.data['success']) {
          setFeedback(t('Sei iscritto!'))
        } else {
          setFeedback(t('Sei già iscritto'))
        }
      })
      .catch((error) => {
        console.error('Error during API call:', error)
        setFeedback(t("Si è verificato un errore durante l'iscrizione."))
      })
  }

  const handleSubscribe = () => {
    if (!utente) {
      setGuest(true)
    } else {
      setConfermaScuola(true)
      setFeedback('')
    }
  }

  return (
    <main className="landing-page">
      <div
        className="w-container-fluid u-background-image"
        style={{ backgroundColor: page.theme_color || '#e6f1fe', paddingBottom: '-3rem' }}
      >
        <div className="w-container">
          <Breadcrumbs breadcrumbs={page.breadcrumbs} />

          <div className="landing">
            <div className="landing__left">
              <h1 className="landing__left__titolo">{page.titolo}</h1>
              <p className="landing__left__descrizione">{page.descrizione}</p>
            </div>
            {shouldShowCta && (
              <div className="landing__right">
                <div className="share">
                  {/*<Share item={page} variant="square" isFormazione={true} labelGTM={'formazione'} />*/}
                  <LandingIscrizione page={page} onClick={handleSubscribe} />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="corso-formazione-modulo__container-moduli corso-formazione-modulo__container-moduli--border">
        <div className="w-container">
          <div className="landing">
            <div className="landing__pagebuilder">
              <PlaceholderReact
                contentTypeId={page.model}
                objectId={page.id}
                pkey="content"
                serverSideContent={newPlaceholder}
              />
            </div>
          </div>
        </div>
      </div>
      {shouldShowCta && guest && (
        <Modal
          isOpen={guest}
          alert={false}
          close={() => setGuest(false)}
          classes="modal__content--wide"
        >
          <div className="modal__content__comunicazione">
            <h3 className="title">{t('Possono iscriversi solo gli utenti registrati.')}</h3>
            <p className="disclaimer">
              {t(
                "Registrati gratuitamente e scopri tutti i vantaggi. In regalo per te 30 giorni di prova a IO+, con tanti contenuti in esclusiva e l'accesso alla community dei docenti Giunti Scuola."
              )}
            </p>
            <Link legacyBehavior href="/registrazione">
              <a
                className="button button--primary cta"
                type="button"
                onClick={() => {
                  setGuest(false)
                }}
              >
                Registrati ora
              </a>
            </Link>
            <div
              className="disclaimer"
              dangerouslySetInnerHTML={{
                __html: t('Registrati ora e accedi a tanti contenuti, <b>sempre aggiornati</b>'),
              }}
            />
            <p>
              Sei già registrato?{' '}
              <a
                className="login"
                onClick={() => {
                  handleLogin(true)
                }}
              >
                Accedi
              </a>
            </p>
          </div>
        </Modal>
      )}
      {shouldShowCta && confermaScuola && (
        <Modal
          isOpen={confermaScuola}
          alert={false}
          close={() => setConfermaScuola(false)}
          classes="modal__content--wide"
        >
          <div className="modal__content__comunicazione">
            <h3 className="title">{feedback ? t('La tua iscrizione') : t('La tua scuola')}</h3>
            {feedback ? (
              <p className="disclaimer">{feedback}</p>
            ) : (
              <>
                <p className="disclaimer">
                  {scuolaObj?.nome_scuola ? (
                    <>
                      {t('Ci risulta che la scuola inserita sia ')}
                      <b>{labelScuola}</b>
                    </>
                  ) : (
                    t('Ci risulta che tu non abbia ancora inserito la scuola.')
                  )}
                </p>
                {!!scuolaObj?.nome_scuola && (
                  <>
                    <Button label={`Iscriviti a ${page.titolo}`} onClick={handleApi} />
                    <br />
                    oppure
                    <br />
                    <br />
                  </>
                )}
                <Button
                  label={scuolaObj?.nome_scuola ? 'Modifica la scuola' : 'Inserisci la scuola'}
                  variant="secondary"
                  onClick={() => router.push('/area-personale/profilo/scuole')}
                />
              </>
            )}
          </div>
        </Modal>
      )}
      {shouldShowCta && login && <Login isOpen={login} next={next} setLogin={handleLogin} />}
    </main>
  )
}

export default LandingTemplate
